import React from "react";
import { Container } from "./styles.js";

type BorderCardProps = {
  title: string;
  subTitle?: string | React.ReactNode;
  children?: React.ReactNode;
  headingLevel?: keyof JSX.IntrinsicElements;
  actions?: React.ReactNode;
  inlineSubTitle?: boolean;
  narrowContainer?: boolean;
};

const BorderCard: React.FC<BorderCardProps> = ({
  title,
  subTitle,
  inlineSubTitle,
  narrowContainer,
  children,
  headingLevel = "h2",
  actions,
}) => {
  const HeadingComponent = headingLevel as React.ElementType;

  return (
    <Container className={`border-card ${narrowContainer ? "narrow" : ""}`}>
      {title && (
        <div className="border-card-heading">
          <HeadingComponent className={`${inlineSubTitle ? "inline" : ""}`}>
            {title}{" "}
            {subTitle && (
              <span>
                {subTitle}
              </span>
            )}
          </HeadingComponent>
          {actions}
        </div>
      )}
      {children && <div className="border-card-content">{children}</div>}
    </Container>
  );
};

export default BorderCard;
